import { Presentation } from '../../core/gameflow/controller/Presentation';
import { GameData } from '../server/data/GameData';
import { Beheaded } from '../Beheaded';
import { Helper } from '../../core/utils/Helper';
import { SoundManager } from '../config/sound/SoundManager';
import { ResizeHelper } from '../../core/utils/ResizeHelper';
import { gsap } from 'gsap';

export class IntroPresentation extends Presentation {
    public static introPlayed = false;
    public introSound = true;

    checkForActivation(data: GameData): boolean {
        if (IntroPresentation.introPlayed) return false;
        let canPlay = !data.isRestoreState && !Beheaded.apiPlugin.isReplay && !IntroPresentation.introPlayed;
        canPlay = canPlay && !!Beheaded.bigWinCounter.parent.parent;
        IntroPresentation.introPlayed = true;

        if (!canPlay) {
            Beheaded.soundPlayer.switchMusic(data.mode);
            Beheaded.bigWinCounter.parent.scale.set(ResizeHelper.isIPadd ? 0.9 : 1);
        }
        return canPlay;
    }

    createPresentation(): void {
        const introDurr: number = 2;
        const toScale: number = ResizeHelper.isIPadd ? 0.9 : 1;

     
        this.timeline.eventCallback("onUpdate",() => {
            if(SoundManager.isLoaded() && this.introSound){
                SoundManager.playIntro(this.timeline);
                this.introSound = false; 
        }})

        // SoundManager.playSoundEffect('intro', 0);

        this.timeline.fromTo(
            Beheaded.bigWinCounter.parent.scale,
            { x: 1, y: 1 },
            { x: 0.65, y: 0.65, duration: 1, ease: 'Back.easeOut' },
            0
        );

        this.timeline.add(Beheaded.overlayAnim.PlayIntroSpine(), 0.2);

        this.timeline.fromTo(
            Beheaded.bigWinCounter.parent.scale,
            { x: 0.65, y: 0.65 },
            { x: toScale, y: toScale, duration: introDurr },
            3
        );

        this.timeline.add(Beheaded.overlayAnim.playIntroDarkFade(introDurr), 3);
        Beheaded.keypadPlugin.toggleVisibility(false);
        
        this.timeline.add(Beheaded.backgroundCharacter.showSmokeLevelUp(1, false), 4.5);

        this.timeline.fromTo(Beheaded.reelEngineManager, { alpha: 0 }, { alpha: 1, duration: 2 }, '-=2');

        Beheaded.souldWildController.enableIntro();

        Helper.clicker(Beheaded.bigWinCounter.parent, () => this.skip());

        this.PresentationState.setInactive();
    }

    public skip(): void {
        super.skip();
        Beheaded.keypadPlugin.toggleVisibility(true);
        SoundManager.stopSoundEffect('intro');
    }

    public done(): void {
        SoundManager.playSoundEffect('introEnd');
        Beheaded.keypadPlugin.toggleVisibility(true);
        Beheaded.souldWildController.disableIndicator(true);

        Helper.clearClickerFromObj(Beheaded.bigWinCounter.parent);
    }
}
